import React from 'react';
import {Box, FormGroup, Stack} from '@mui/material';
import {DesktopDatePicker, LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';
import {Moment} from 'moment';
import SelectList from '../../form-components/SelectList.component';
import SearchField from '../../form-components/SearchField.component';
import {SelectChangeEvent} from '@mui/material/Select';
import {ExplorerTypeConfig} from './explorer-config';

interface ExplorerFiltersProps {
    config: ExplorerTypeConfig;
    selectedResource: number;
    searchText: string;
    newOccurrenceStartSearchDate: Moment | null;
    newOccurrenceEndSearchDate: Moment | null;
    selectedDescriptorType: number;
    additionalResourceItems: {id: number, name: string}[];
    descriptorTypes: Array<{id: number, name: string}>;
    onResourceChange: (event: React.ChangeEvent<{ value: unknown }>) => void;
    onSearchTextChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onStartDateChange: (date: Moment | null) => void;
    onEndDateChange: (date: Moment | null) => void;
    onDescriptorTypeChange: (event: SelectChangeEvent<number>) => void;
}

/**
 * Filter controls for the Explorer component
 */
export const ExplorerFilters: React.FC<ExplorerFiltersProps> = ({
    config,
    selectedResource,
    searchText,
    newOccurrenceStartSearchDate,
    newOccurrenceEndSearchDate,
    selectedDescriptorType,
    additionalResourceItems,
    descriptorTypes,
    onResourceChange,
    onSearchTextChange,
    onStartDateChange,
    onEndDateChange,
    onDescriptorTypeChange
}) => {
    return (
        <FormGroup>
            {config.showGroupSelector && (
                <SelectList
                    value={selectedResource}
                    label={'Select Working Area'}
                    items={additionalResourceItems}
                    onChange={onResourceChange} 
                />
            )}

            {config.showDescriptorTypeSelector && (
                <Box sx={{ padding: '15px 0 5px 0'}}>
                    <SelectList
                        value={selectedDescriptorType}
                        label={'Select Descriptor Type'}
                        skipInitialSelector={true}
                        items={descriptorTypes}
                        onChange={onDescriptorTypeChange}
                    />
                </Box>
            )}

            <SearchField 
                label='' 
                value={searchText} 
                onTextChange={onSearchTextChange} 
                onClick={onSearchTextChange} 
            />

            {config.showDatePicker && (
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <Stack direction='row' spacing={2} sx={{ mt: 1 }}>
                        <DesktopDatePicker
                            label="Search Start Date"
                            aria-label='search start date'
                            format='MM/DD/YYYY'
                            value={newOccurrenceStartSearchDate}
                            onChange={onStartDateChange}
                            slotProps={{
                                textField: {
                                    size: 'small',
                                    variant: 'outlined',
                                },
                                field: {
                                    clearable: true,
                                    onClear: (): void => {
                                        onStartDateChange(null);
                                    }
                                },
                            }}
                        />
                        <DesktopDatePicker
                            label="Search End Date"
                            aria-label='search end date'
                            format='MM/DD/YYYY'
                            value={newOccurrenceEndSearchDate}
                            onChange={onEndDateChange}
                            slotProps={{
                                textField: {
                                    size: 'small',
                                    variant: 'outlined',
                                },
                                field: {
                                    clearable: true,
                                    onClear: (): void => {
                                        onEndDateChange(null);
                                    }
                                },
                            }}
                        />
                    </Stack>
                </LocalizationProvider>
            )}
        </FormGroup>
    );
};